import React from 'react';
import { Link } from '@reach/router';
import styled from 'styled-components';
//
const isUK = ({ location, ...rest }) => {
  const { pathname } = location;
  if (!pathname) {
    return null;
  }
  return pathname.startsWith('/us') ? null : { className: 'active' };
};

const isPartiallyActive = ({ isPartiallyCurrent }) => {
  return isPartiallyCurrent ? { className: 'active' } : null;
};
//
export default () => (
  <Wrap>
    <Item>
      <Link to="/" title="UK" getProps={isUK}>
        UK
      </Link>
    </Item>

    <Item>
      <Link to="/us" title="US" getProps={isPartiallyActive}>
        US
      </Link>
    </Item>
  </Wrap>
);
//
const Wrap = styled.ul`
  margin: 0 0 0.5rem;
`;
const Item = styled.li`
  display: inline-block;

  &:not(:last-child) {
    &:after {
      content: '|';
      padding: 0 0.5rem;
    }
  }

  a {
    &.active {
      font-weight: 700;
    }
  }
`;
